import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = l((c, f) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: f,
    ...c,
    image: (i) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 3375,
        height: 2125,
        fill: "none",
        viewBox: "0 0 3375 2125",
        ...i,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#0079BE",
              d: "M1918.59 2124.99c581.25 2.78 1111.78-473.66 1111.78-1053.26C3030.37 437.899 2499.84-.21 1918.59 0h-500.23C830.154-.21 346 438.03 346 1071.73c0 579.73 484.154 1056.04 1072.36 1053.26z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#fff",
              d: "M1421.16 86.98c-537.5.168-973.057 435.747-973.184 973.34.127 537.5 435.68 973.03 973.184 973.2 537.64-.17 973.28-435.7 973.36-973.2-.08-537.593-435.72-973.172-973.36-973.34m-616.873 973.34c.507-262.699 164.611-486.711 396.023-575.73v1151.32c-231.412-88.97-395.521-312.86-396.023-575.59m837.653 575.84V484.552c231.49 88.804 395.85 312.942 396.27 575.768-.42 262.9-164.78 486.87-396.27 575.84"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#0079BE",
              d: "M1918.59 2124.99c581.25 2.78 1111.78-473.66 1111.78-1053.26C3030.37 437.899 2499.84-.21 1918.59 0h-500.23C830.154-.21 346 438.03 346 1071.73c0 579.73 484.154 1056.04 1072.36 1053.26z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#fff",
              d: "M1421.16 86.98c-537.5.168-973.057 435.747-973.184 973.34.127 537.5 435.68 973.03 973.184 973.2 537.64-.17 973.28-435.7 973.36-973.2-.08-537.593-435.72-973.172-973.36-973.34m-616.873 973.34c.507-262.699 164.611-486.711 396.023-575.73v1151.32c-231.412-88.97-395.521-312.86-396.023-575.59m837.653 575.84V484.552c231.49 88.804 395.85 312.942 396.27 575.768-.42 262.9-164.78 486.87-396.27 575.84"
            }
          )
        ]
      }
    )
  }
));
t.displayName = "DinersClubIcon";
export {
  t as DinersClubIcon,
  t as default
};
//# sourceMappingURL=index.js.map
